import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerifyOtp from "./VerifyOtp";
import ResetPassword from "../../Sections/Auth/ResetPassword";
import { verifyAccountAction } from "../../Actions/UserActions";
import SetInitialPassword from "./SetInitialPassword";
import CustomSnackbar from "../../Sections/Common/snackBar";


const VerifyAccount = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    const [step, setStep] = useState("otp");
    const [passwordToken, setPasswordToken] = useState(null);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "error",
    });

    const handleCloseSnackbar = () => {
        setSnackbar((prev) => ({
            ...prev,
            open: false,
        }));
    };

    const navigate = useNavigate();

    useEffect(() => {
        if (token) verifyLink();
    }, [token]);

    const verifyLink = async () => {
        try {
            await verifyAccountAction(token); 
            
        } catch (err) {
            setSnackbar({
                open: true,
                message:
                    err.response?.data?.message ||
                    "Invalid or expired verification link.",
                severity: "error",
            });
            setTimeout(() => {
                navigate("/login");
            }, 3000);
        }
    };

    return (
        <>
            {step === "otp" ? (
                <VerifyOtp
                    token={token}
                    onSuccess={(newToken) => {
                        setPasswordToken(newToken);
                        setStep("password");
                    }}
                />
            ) : (
                <SetInitialPassword token={passwordToken} />
            )}

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </>
    );
};


export default VerifyAccount;
